module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }